import { useTranslation } from '../../../i18n/useTranslation';
import { getBuyerContacts } from '../../../components/shopping-cart/services/shopping-cart.service';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {
    Dialog,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    IconButton,
    DialogTitle,
} from '@mui/material';
import BuildingSitesListSkeleton from '../../building-sites-list/building-sites-list-skeleton';
import { IBuyerContactListView } from '../../../components/order/interfaces/buyer-contact-list-view.interface';

interface Prop {
    isOpen: boolean;
    handleCloseDialog: Function;
    parentContractorId: string;
}

const SelectContactDialog: React.FC<Prop> = ({ isOpen, parentContractorId, handleCloseDialog }) => {
    const { t } = useTranslation('translation');
    const [page] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [contacts, setContacts] = useState<IBuyerContactListView[]>([]);

    const handleClose = (selectedContact: IBuyerContactListView | null) => {
        handleCloseDialog(selectedContact);
    };

    const getAndSetContacts = (page: number) => {
        setIsLoading(true);
        getBuyerContacts(parentContractorId, page).then((response) => {
            if (response) {
                const data: IBuyerContactListView[] = response.data;
                setContacts(data);
                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        });
    };

    useEffect(() => {
        if (isOpen && parentContractorId) {
            getAndSetContacts(page);
        }
    }, [isOpen, parentContractorId]);

    return (
        <div>
            <Dialog open={isOpen} onClose={() => handleClose(null)} fullWidth maxWidth="md">
                <DialogTitle
                    sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        bgcolor: 'background.paper',
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    {t('SELECT_CONTACT')}

                    <IconButton
                        onClick={() => handleClose(null)}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ position: 'relative', mt: 1 }}>
                    {isLoading ? (
                        <BuildingSitesListSkeleton count={3} />
                    ) : (
                        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('FIRST_NAME')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('LAST_NAME')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('CONTACT_TYPE')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('EMAIL')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('PHONE')}</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {contacts.map((item) => (
                                        <TableRow
                                            onClick={() => {
                                                handleClose(item);
                                            }}
                                            key={item.id}
                                            sx={{ '&:hover': { backgroundColor: '#f2f2f2', cursor: 'pointer' } }}
                                        >
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.firstName}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.lastName}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.contactType}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.email}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.phone}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};
export default SelectContactDialog;
